import React from "react";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faDollarSign } from '@fortawesome/free-solid-svg-icons'
// import { faClock } from '@fortawesome/free-solid-svg-icons'
// import { faCalendar } from '@fortawesome/free-solid-svg-icons'
// import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'

const ButtonSelection = () => {
  return (
    <div className="FormListitemforsale">
      {/* Button Selection  */}
      <div class="container">
        <div class="row">
          <div class="col text-center btncol active">
            {/* <FontAwesomeIcon icon={faDollarSign} className="mb-4" /> <br /> */}
            <button type="button" class="btn btntext active">
              Fixed Price
            </button>
          </div>
          <div class="col text-center btncol">
            {/* <FontAwesomeIcon icon={faClock} className="mb-4" /> <br /> */}
            <button type="button" class="btn btntext">
              Time Auction
            </button>
          </div>
        </div>
      </div>
      {/* Pricing Input  */}
      <div class="row">
        <div class="col ">
          <h5 className="my-5">Price :</h5>
        </div>
        <div class="col textright">
          {/* <FontAwesomeIcon icon={faCircleInfo}  className="my-5"/> */}
        </div>
      </div>

      <form class="row g-3">
        <div class="col-md-2">
          <select
            id="inputState"
            class="form-select formchoose"
            defaultValue={"ETH"}
          >
            <option selected>Choose...</option>
            <option>ETH</option>
            <option>GRT</option>
            <option>BNF</option>
          </select>
        </div>
        <div class="col-md-10">
          <input
            type="text"
            class="form-control forminput"
            id="inputmethod"
            placeholder="Amount"
          />
        </div>
      </form>
      {/* Duration Input */}

      <div class="row">
        <div class="col ">
          <h5 className="my-5">Duration :</h5>
        </div>
        <div class="col textright">
          {/* <FontAwesomeIcon icon={faCircleInfo}  className="my-5"/> */}
        </div>
      </div>

      <form class="row g-3">
        <div class="col-md-2 iconduration">
          {/* <FontAwesomeIcon icon={faCalendar} /> */}
        </div>
        <div class="col-md-10">
          <input
            type="text"
            class="form-control forminput"
            id="inputmethod"
            placeholder="7 Days"
          />
        </div>
      </form>
      {/* Accordian (More Options)  */}

      <h6 className="moreoptbtn"> More Options</h6>

      {/* Total Amount (Fees)  */}

      <div class="row cardrow">
        <div class="col ">
          <p className="card-text">Fees</p>
          <h6 className="cardtitle">Service Fee</h6>
        </div>
        <div class="col textright">
          {/* <p> <FontAwesomeIcon icon={faCircleInfo} /></p> */}
          <h6 className="cardtitle">2.5%</h6>
        </div>
      </div>

      <button type="button" class="btn btntextbottom">
        Complete Listing
      </button>
    </div>
  );
};

export default ButtonSelection;
